<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" size="small">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.order_goods_label_orderGoodsNo') || '产品编号'"
          >
            <el-input v-model="formData.orderGoodsNo" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item
            :label="
              $l('INDEX.order_goods_label_identifyGoodsNo') || '产品识别编号'
            "
          >
            <el-input v-model="formData.identifyGoodsNo" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.order_goods_label_orderGoodsName') || '产品名称'"
          >
            <el-input v-model="formData.orderGoodsName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('order_goods_orderGoodsNameEn') || '产品英文名称'"
          >
            <el-input v-model="formData.orderGoodsNameEn" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$l('INDEX.label_master_category') || '主分类'">
            <el-input v-model="formData.masterCategoryName" readonly>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.label_detail_category') || '明细分类'"
          >
            <el-input v-model="formData.categoryName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.order_goods_label_orderGoodsPattern') || '花型'"
          >
            <el-input v-model="formData.orderGoodsPattern" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('order_goods_orderGoodsPatternEn') || '花型英文名称'"
          >
            <el-input v-model="formData.orderGoodsPatternEn" readonly>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.order_goods_label_orderGoodsColor') || '产品颜色'"
          >
            <el-input v-model="formData.orderGoodsColor" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('order_goods_orderGoodsColorEn') || '英文颜色'"
          >
            <el-input v-model="formData.orderGoodsColorEn" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('order_goods_orderGoodsUnit') || '产品单位'">
            <el-input v-model="formData.v_orderGoodsUnit" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.order_goods_label_orderGoodsEnglishSize') || '英文尺寸'
            "
          >
            <el-input v-model="formData.v_orderGoodsEnglishSize" readonly>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="5">
          <el-form-item :label="$l('INDEX.order_goods_label_qty') || '数量'">
            <el-input v-model="formData.qty" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="
              $l('tc_order_goods_price') + ' ' + formData.v_currencyUnit ||
                '成本价' + ' ' + formData.v_currencyUnit
            "
          >
            <el-input v-model="formData.price" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="$l('tc_order_goods_tcPrice') || 'TC工厂价格'"
            prop="tcPrice"
          >
            <el-input-number
              v-model="formData.tcPrice"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              controls-position="right"
              style="width:100%"
              :max="999999"
              :min="0"
              :step="0.01"
              :precision="4"
              :disabled="disabled"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('INDEX.goods_label_isGroup') || '是否套装'">
            <el-input v-model="formData.v_isGroup" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="$l('INDEX.order_goods_label_inPackageQty') || '装箱入数'"
          >
            <el-input v-model="formData.inPackageQty" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.product_dialog_btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    tcOrderGoodsCode: { type: String, default: '' },
  },
  data() {
    return {
      backDialogVisible: false,
      formData: {},
      rules: {
        tcPrice: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.tcOrderGoodsCode) return
      this.$api
        .tcOrderGoodsDetailApi({
          tcOrderGoodsCode: this.tcOrderGoodsCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      this.loadingOpen()
      const res = await this.$api
        .tcOrderGoodsUpdateApi(this.formData)
        .catch(() => null)
      this.loadingClose()
      const { status } = res || {}
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
